import React, { PropsWithChildren } from 'react';

import { Box } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import { COLORS } from 'theme/constants';

import { Tooltip, Typography, List, ListItem } from './style';

interface PasswordChecklistProps {
  password: string;
  open: boolean;
  children: JSX.Element;
}

export const PasswordChecklist = ({ password, open, children }: PropsWithChildren<PasswordChecklistProps>) => {
  const rules = [
    {
      valid: password.length >= 6,
      message: 'At least 6 characters',
    },
  ];

  return (
    <Tooltip
      title={
        <>
          <Typography>Password must have:</Typography>
          <List>
            {rules.map((rule, index) => (
              <ListItem key={`rule-${index}`} style={{ color: rule.valid ? COLORS.builderSuccessText : '' }}>
                {rule.valid ? <CheckIcon /> : <FiberManualRecordIcon className="dot" />} {rule.message}
              </ListItem>
            ))}
          </List>
        </>
      }
      placement="right"
      open={open}
      arrow
    >
      <Box style={{ width: '100%' }}>{children}</Box>
    </Tooltip>
  );
};
